import React from 'react';
import Typography from '@visa/vds/typography';
import Grid from '@visa/vds/grid';
import MCSSpace from '../../components/MCSSpace';
import PagePic from '../../_imgs/illustrations/scene/illustration-scene-inspector-blue-beard.svg';
function NotFound(){
    return (
           
      <Grid>
        <MCSSpace height="50px" />
        <Typography style={{ textAlign:"center",margin:"auto" }} tag="h1">Page Not Found</Typography>
        <MCSSpace />
        <img style={{ width:"235px", margin:"auto" }} src={PagePic}/>
        <MCSSpace />
      </Grid>
        
    );
  }


export default NotFound;
